/**
 * Sets a new location.
 *
 * @param {string} href - The target url or pathname.
 */
export const gotoPage = (href) => {
    if (window.location.pathname !== href) {
        location.href = href;
    }
};
//# sourceMappingURL=router.js.map